import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const walletVuex = createNamespacedHelpers("wallet");
const chatVuex = createNamespacedHelpers("chat");
import EasyTyper from "@assets/js/easyTyper";
export default {
  name: "index",
  computed: {
    ...userVuex.mapState(["isLogin", "userInfo", "settingInfo", "token"]),
    ...walletVuex.mapState(["isMobile", "deviceType"]),
    ...chatVuex.mapState(["chatInfo"])
  },
  data() {
    return {
      isGuideTab: 0,
      isTab: 1,
      chatText: "",
      textareaRows: 1,
      initialScrollTop: 0,
      isMenuShow: true,
      indexBodyHeight: 0,
      xx: "111",
      easyTyperConfig: {
        output: "",
        // 输出内容  使用MVVM框架时可以直接使用
        type: "rollback",
        isEnd: false,
        speed: 15,
        backSpeed: 40,
        sleep: 3000,
        singleBack: true,
        sentencePause: true
      },
      chatLoading: false,
      _viewportHeight: 0,
      viewportHeight: 0,
      keyboardHeight: 0,
      isMenuHeight: 0
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        this._viewportHeight = this.WebApp.viewportHeight;
      },
      deep: true,
      immediate: true
    },
    isGuideTab: {
      async handler(newTab, oldTab) {
        if (newTab != oldTab && newTab == 1) {
          await this.initFnc();
        }
      },
      deep: true,
      immediate: true
    },
    isTab: {
      handler(newTab, oldTab) {
        if (newTab != oldTab) {
          this.scrollToBottom();
        }
      }
    }
  },
  methods: {
    ...chatVuex.mapActions(["getChatHistory", "chatTextFnc"]),
    setIndexBodyHeight(isMenu) {
      this.$nextTick(() => {
        const indexPageRef = this.$refs.indexPageRef;
        const headRef = this.$refs?.mHeadRef?.$el;
        const menuRef = this.$refs?.mMenuRef?.$el;
        const wrapperRef = this.$refs.wrapperRef;
        const indexPageHeight = indexPageRef.offsetHeight;
        let menuRefHeight = this.deviceType == "pc" || menuRef?.offsetHeight ? menuRef.offsetHeight : 0;
        if (isMenu == "init") {
          this.isMenuHeight = menuRefHeight;
        } else if (isMenu == "four") {
          menuRefHeight = 0;
        } else if (isMenu == "blur" || isMenu == "clear") {
          menuRefHeight = this.isMenuHeight;
        }
        const headRefHeight = headRef.offsetHeight;
        const wrapperRefHeight = wrapperRef?.offsetHeight;
        this.viewportHeight = this.WebApp.viewportHeight;
        this.keyboardHeight = this._viewportHeight - this.WebApp.viewportHeight;
        const transformY = this.keyboardHeight > 0 ? 15 : 0;
        this.indexBodyHeight = indexPageHeight - menuRefHeight - headRefHeight - wrapperRefHeight - transformY + "px";
        console.log("this.indexBodyHeight", this.indexBodyHeight);
      });
    },
    insertDateTagsByDay(arr) {
      const formatDate = timestamp => {
        const date = new Date(timestamp);
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const day = String(date.getUTCDate()).padStart(2, "0");
        return `${month}-${day}`;
      };
      const result = [];
      let lastDate = "";
      for (const item of arr) {
        const dateKey = new Date(item.timestamp).toISOString().split("T")[0]; // YYYY-MM-DD
        const formattedDate = formatDate(item.timestamp);
        if (dateKey !== lastDate) {
          lastDate = dateKey;
          result.push({
            ...item,
            dateTag: formattedDate
          });
        } else {
          result.push(item);
        }
      }
      return result;
    },
    async initFnc() {
      this.setIndexBodyHeight("init");
      const chatList = await this.getChatHistory();
      if (!chatList) {
        return;
      }
      this.chatInfo.chatList = this.insertDateTagsByDay(chatList.messages);
      if (this.chatInfo.chatList && this.chatInfo.chatList.length > 0) {
        this.chatInfo.conversation_id = this.chatInfo.chatList[this.chatInfo.chatList.length - 1]?.conversation_id;
      }
      this.scrollToBottom();
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const indexChatsRef = this.$refs.indexChatsRef;
        if (!indexChatsRef || !this.$refs.indexBodysRef) return;
        this.$refs.indexBodysRef.scrollTop = indexChatsRef.scrollHeight;
        console.log("this.chatInfo.conversation_id", this.chatInfo.conversation_id);
      });
    },
    onTab(value) {
      this.isTab = value;
    },
    onTextareaFocus() {
      this.isMenuShow = false;
      this.adjustTextareaHeight();
      setTimeout(() => {
        this.setIndexBodyHeight("focus");
        this.viewportHeight = this.WebApp.viewportHeight;
        this.keyboardHeight = this._viewportHeight - this.WebApp.viewportHeight;
        this.resetCursor();
        if (this.keyboardHeight > 0 && this.deviceType === "ios_large") {
          this.$refs.wrapperRef.style.bottom = 12 + (this.textareaRows <= 1 ? this.textareaRows : this.textareaRows + 12) + "px";
        }
        this.scrollToBottom();
        console.log(document.documentElement.offsetHeight);
        console.log(document.documentElement.scrollTop);
        console.log("keyHeightxxxxxxx", this._viewportHeight, this.WebApp.viewportHeight);
      }, 100);
    },
    onTextareaBlur() {
      this.isMenuShow = true;
      setTimeout(() => {
        document.documentElement.scrollIntoView(false);
        this.adjustTextareaHeight();
        this.setIndexBodyHeight("blur");
      }, 50);
    },
    onTextareaInput(e) {
      this.textareaRows = 1;
      setTimeout(() => {
        this.textareaRows = this.getTextareaRenderedLines(this.$refs.textareaRef);
        this.adjustTextareaHeight();
        this.setIndexBodyHeight("input");
        this.scrollToBottom();
      }, 10);
    },
    resetCursor() {
      // const textarea = this.$refs.textareaRef;
      // const el = textarea.value;
      // if (!el) return;
      // const pos = el.selectionStart;
      // // 强制刷新
      // el.blur();
      // setTimeout(() => {
      //   el.focus();
      //   el.setSelectionRange(pos, pos);
      //   // 微调触发 repaint
      //   el.style.transform = "translateY(0.1px)";
      //   requestAnimationFrame(() => {
      //     el.style.transform = "";
      //   });
      // }, 100);
    },
    getTextareaRenderedLines(textarea) {
      if (!textarea) {
        return;
      }
      const style = window.getComputedStyle(textarea);
      const lineHeight = parseFloat(style.lineHeight);
      const paddingTop = parseFloat(style.paddingTop);
      const paddingBottom = parseFloat(style.paddingBottom);
      const totalHeight = textarea.scrollHeight - paddingTop - paddingBottom;
      return Math.round(totalHeight / lineHeight);
    },
    adjustTextareaHeight() {
      const textarea = this.$refs.textareaRef;
      if (!textarea) return;
      textarea.style.height = "auto";
      let scrollHeight = textarea.scrollHeight;
      if (scrollHeight >= 120) {
        scrollHeight = 120;
      }
      textarea.style.height = scrollHeight + "px";
    },
    clearTextarea() {
      // 清空 textarea
      const textarea = this.$refs.textareaRef;
      this.isMenuShow = true;
      // 关闭键盘
      textarea.blur();
      setTimeout(() => {
        this.textareaRows = 1;
        this.chatText = "";
        this.adjustTextareaHeight();
        this.onTextareaBlur();
        this.setIndexBodyHeight("clear");
      }, 50); // 延迟一点时间再清空
    },

    indexBodyTouchMove() {
      const textarea = this.$refs.textareaRef;
      if (!textarea) return;
      this.$nextTick(() => {});
      setTimeout(() => {
        textarea.blur();
        this.isMenuShow = true;
        this.adjustTextareaHeight();
        this.onTextareaBlur();
        this.setIndexBodyHeight("clear");
      }, 100); // 延迟一点时间再清空
    },

    async onSend() {
      if (!this.chatText) {
        this.$toasted.clear();
        this.$toasted.info("What do you need to tell me?");
        return;
      }
      const textarea = this.$refs.textareaRef;
      const text = textarea.value.trim();
      if (!text) return;
      await this.onChat();
    },
    async onChat() {
      if (!this.chatText) {
        this.$toasted.clear();
        this.$toasted.info("What do you need to tell me?");
        return;
      }
      if (this.chatLoading) return;
      this.chatLoading = true;
      let params = {
        text: this.chatText
      };
      if (this.chatInfo.conversation_id) {
        params["conversation_id"] = this.chatInfo.conversation_id;
      }
      const userChat = {
        role: "user",
        content: this.chatText,
        conversation_id: null,
        timestamp: null
      };
      this.chatInfo.chatList.push(userChat);
      this.scrollToBottom();
      this.chatText = "";
      this.clearTextarea();
      await new Promise(resolve => setTimeout(resolve, 1000));
      const assistantChat = {
        role: "assistant",
        content: `<span class="mexican-wave"></span>`,
        conversation_id: null,
        timestamp: null
      };
      this.chatInfo.chatList.push(assistantChat);
      this.scrollToBottom();
      const res = await this.chatTextFnc(params);
      if (!res) {
        this.chatLoading = false;
        return;
      }
      const textList = [res.answer];
      this.chatInfo.conversation_id = res.metadata.conversation_id;
      this.chatInfo.chatList[this.chatInfo.chatList.length - 1].conversation_id += res.metadata.conversation_id;
      new EasyTyper(this.easyTyperConfig, textList, () => {
        this.chatLoading = false;
        this.indexBodyTouchMove();
      }, (output, instance) => {
        this.chatInfo.chatList[this.chatInfo.chatList.length - 1].content = `${output}`;
        this.scrollToBottom();
      });
    }
  },
  mounted() {},
  beforeDestroy() {}
};